<template>
  <van-empty :description="desc" :image-size="imgSize">
    <template v-slot:image>
      <img :src="imgSrc||imgList[showType]" alt="" :style="{width:imgWidth,height:imgHeight}" :class="[imgClass]">
    </template>
    <van-button v-if="showBtn" round type="danger" class="bottom-button" @click="btnClick">{{btnText}}</van-button>
    <template v-slot:description>
      <slot name="description"></slot>
    </template>
   
  </van-empty>
</template>

<script>
/**
 * @description 缺省页面
 * @param {String} desc 描述文字
 * @param {String} showType 显示缺省类型 data,coupon,search
 * @param {Boolean} showBt 是否显示按钮
 */
export default {
  name:'no-data',
  data(){
    return {
      imgList:{
        data:require('@/assets/images/nodata.png'),
        coupon:require('@/assets/coupon-imgs/empty-coupon.png'),
        search:require("@/assets/images/emptylist.png"),
        help:require('@/assets/help/no-ac.png')
      }
    }
  },
  props:{
    desc:{
      type:String,
      default:'暂无数据'
    },
    showType:{
      type:String,
      default:'data'
    },
    showBtn:{
      type:Boolean,
      default:false
    },
    btnText:{
      type:String,
      default:'确定'
    },
    imgWidth:{
      type:String,
      default:'100%'
    },
    imgHeight:{
      type:String,
      default:'100%'
    },
    imgClass:{
      type:String,
      default:''
    },
    imgSrc:{
      type:String,
      default:''
    },
    imgSize:{
      type:[String,Number],
      default:210
    }
  },
  methods:{
    btnClick:function(){
      this.$emit('btnClick')
    }
  }
}
</script>